import { Box, Text, Input, Button} from "@chakra-ui/react";
import backgroundTop from "../assets/background-top.png"
import background from "../assets/bg.jpg"
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getProfile } from "../store/actionCreators/userAction";
import { baseUrl } from "../apis/baseUrl";
import { ACCENT_1_COLOR } from "../constants/color";

export default function Login() {
  const [userLogin, setUserLogin] = useState({
    email: "",
    password: ""
  })
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setUserLogin({...userLogin, [name]: value})
  }

  const handleLogin = async () => {
    try {
      const res = await baseUrl.post("/login", userLogin)
      localStorage.setItem("access_token", res.data.accessToken);
      dispatch(getProfile());
      navigate("/")
    } catch (error) {
      console.log(error,'ini error')
    }
  }

  return (
    <Box display={"flex"} minH={"100vh"} width={"100vw"} background={`transparent url(${background})`}>
      <Box bgRepeat={"repeat-x"} backgroundImage={`url(${backgroundTop})`} width={"100vw"} h={"100vh"}>
        {/* <Menubar/> */}
        <Box mx={"36px"} display={"flex"} justifyContent={"flex-end"} alignItems={"center"} h={"100px"}>
          <Text onClick={() => navigate("/")} fontSize={"24px"} _hover={{cursor: "pointer", textColor: ACCENT_1_COLOR}} textColor={"#43525a"}>Back to Home</Text>
        </Box>
        <Box height={"75%"} display={"flex"} alignItems={"center"} justifyContent={"center"}>
          <Box height={"250px"} w={"400px"} padding={"24px"}  boxShadow={"10px 10px 15px"} borderRadius={"8px"} alignItems={"center"} justifyContent={"center"} display={"flex"} flexDir={"column"}>
            <Box mb={"8px"} w={"100%"}>
            <Text textAlign={"left"} ml={"8px"}>Email</Text>
            <Input placeholder="your email" type="email" name="email" value={userLogin.email} onChange={(e) => handleChange(e)}></Input>
            </Box>
            <Box w={"100%"}>
            <Text textAlign={"left"} ml={"8px"}>Password</Text>
            <Input placeholder="your password" type="password" name="password" value={userLogin.password} onChange={(e) => handleChange(e)}></Input>
            </Box>
            <Box w={"100%"} alignItems={"center"} justifyContent={"center"} display={"flex"} mt={"12px"}>
              <Button onClick={() => handleLogin()}>Sign In</Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
